let itinerary = {
  'model': {

    'itineraryType': {
      'title': 'Sottomenù',
      'type': 'select',
      'enum': ['TREKKING', 'BICI'],
      'prefix': 'vm.item.itinerary',
      'required': true
    },
    'title': {
      'title': 'Titolo',
      'type': 'input',
      'prefix': 'lang',
      'required': true
    },

    'municipality': {
      'title': 'Comune',
      'type': 'input',
      'prefix': 'vm.item.itinerary',
      'required': false
    },

    'category': {
      'title': 'Categoria',
      'type': 'input',
      'prefix': 'vm.item.itinerary',
      'required': false
    },

    'phoneNumber': {
      'title': 'Numero di telefono',
      'type': 'input',
      'prefix': 'vm.item.itinerary',
    },

    'eMail': {
      'title': 'E-mail',
      'type': 'input',
      'prefix': 'vm.item.itinerary',
    },

    'webSite': {
      'title': 'Sito web',
      'type': 'input',
      'prefix': 'vm.item.itinerary',
    },

    'description': {
      'title': 'Descrizione',
      'type': 'editor',
      'prefix': 'lang',
      'row': 8,
    },

    'location': {
      'title': 'Ubicazione',
      'type': 'input',
      'prefix': 'lang',
      'required': true
    },

    'timetable': {
      'title': 'Orari e stagionalità',
      'type': 'input',
      'prefix': 'lang',
    },

    'note': {
      'title': 'Note',
      'type': 'editor',
      'prefix': 'lang',
      'row': 2,
    },

    'additionalInformations': {
      'title': 'Approfondisci',
      'type': 'editor',
      'prefix': 'lang',
      'row': 2,
    },

    'geojson': {
      'title': 'Geojson (Solamente la parte contenente le coordinate geografiche ad esempio [[7.98 , 10.25],[7.99, 10.26]]  )',
      'type': 'numeric-array',
      'prefix': 'vm.item.itinerary',
      'row': 10,
      'required': true
    },

  },
};

export default itinerary;



// WEBPACK FOOTER //
// ./client/app/common/factories/modelFactory/itinerary.model.js